import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { ActivityService } from '../proxy/controlling/controllers/activity.service';
FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPEACTIVITY_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('activityId', 'Entity.Activity', ActivityService)
    .displayFromNested('activity.name')
    .sortBy('activity.name')
    .build(),
  FieldBuilder.checkbox('isReferenceActivity', 'Entity.ContractTypeActivity.IsReferenceActivity')
    .build(),
  FieldBuilder.checkbox('isActivityLiquidated', 'Entity.ContractTypeActivity.IsActivityLiquidated')
    .build(),
  FieldBuilder.checkbox('isActivityValidatedByMgs', 'Entity.ContractTypeActivity.IsActivityValidatedByMgs')
    .build(),
];

export const CONTRACTTYPEACTIVITY_CONFIG = {
  entityName: 'ContractTypeActivity',
  localizationKey: 'Controlling::Entity.ContractTypeActivity',
  fields: CONTRACTTYPEACTIVITY_FIELDS,
  permission: 'Controlling.ContractTypeActivities',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
